import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import { TypographyRows } from 'src/app/components/Elements/Typography/Sections';
import { theme } from 'src/styles/theme';

import LinkToCardItem from '../LinkToCardItem';

import { CardErrorTitle, CardItemInfoText, CardItemTitle, TextAndIconContainer } from './styles';

interface StylizedCardItemLinkWithIconProps {
  to: string;
  sectionTitle: string;
  textList: string[];
  capsuleIcon: string;
  ariaLabel: string;
  isDisabled: boolean;
  handleOnClick?: (e: Event) => void;
  dataCy?: string;
  disabledText?: string;
  footerMessage?: any;
  shouldBoldFirstText?: boolean;
  showArrow?: boolean;
  noMaxWidth?: boolean;
  wrapperClass?: string;
  padding?: string;
  hasError?: boolean;
  [key: `data-${string}`]: any;
}

export const StylizedCardItemLinkWithIcon = ({
  to,
  sectionTitle,
  textList,
  capsuleIcon,
  ariaLabel,
  handleOnClick,
  dataCy,
  isDisabled,
  disabledText,
  footerMessage,
  shouldBoldFirstText = false,
  showArrow = true,
  noMaxWidth,
  wrapperClass,
  padding = '1',
  hasError = false,
  'data-testid': testId,
  ...rest
}: StylizedCardItemLinkWithIconProps) => {
  return (
    <LinkToCardItem
      className={wrapperClass}
      disabled={isDisabled}
      to={to}
      onClick={handleOnClick}
      aria-label={ariaLabel}
      showArrow={showArrow}
      data-cy={dataCy}
      data-testid={testId ?? dataCy}
      isDisabled={isDisabled}
      noMaxWidth={noMaxWidth}
      padding={padding}
      {...rest}
    >
      {hasError ? <CardErrorTitle>{sectionTitle}</CardErrorTitle> : <CardItemTitle>{sectionTitle}</CardItemTitle>}
      <TextAndIconContainer>
        <CapsuleIcon iconString={capsuleIcon} block />
        {isDisabled ? (
          <CardItemInfoText>{disabledText}</CardItemInfoText>
        ) : (
          <div>
            <TypographyRows
              paddingLeft={theme.space[padding]}
              textList={textList}
              shouldBoldFirstRow={shouldBoldFirstText}
            />
            {footerMessage}
          </div>
        )}
      </TextAndIconContainer>
    </LinkToCardItem>
  );
};
